import React from 'react'
import PropTypes from 'prop-types'
import SidebarSubSection from 'components/Onboarding/PWMSidebar/SidebarSubSection/SidebarSubSection'
import styles from './AccountHolderFormGroup.module.scss'
import C from 'actionTypes/routing'

const AccountHolderFormGroup = (props) => {
  const {
    overview,
  } = props

  return (
    <ul className={styles.AccountHolderFormGroup}>
      <SidebarSubSection
        styles={styles}
        to={{ type: C.ONBOARDING_PERSONAL_INFORMATION }}
        name="Personal Information"
        sectionComplete={overview.personalInformation.complete} />
      <SidebarSubSection
        styles={styles}
        to={{ type: C.ONBOARDING_IDENTITY_VERIFICATION }}
        name="Identity Verification"
        sectionComplete={overview.identityVerification.complete} />
      <SidebarSubSection
        styles={styles}
        to={{ type: C.ONBOARDING_EMPLOYMENT_DETAILS }}
        name="Employment Details"
        sectionComplete={overview.employmentDetails.complete} />
    </ul>
  )
}

AccountHolderFormGroup.propTypes = {
  overview: PropTypes.object.isRequired,
}

export default AccountHolderFormGroup



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/AccountHolderFormGroup/AccountHolderFormGroup.jsx